module.exports = __webpack_public_path__ + "static/media/drone-port.ff66f3e4.jpg";